import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
export default function GalleryPage() {
        document.title = "Gallery - IGSOSA";
    return(
    <>
     <Gallery isHomepage={false} maxRecords={6} />
        <Footer></Footer>
     </>
     
    );
}
